import React,{useEffect,useState}from 'react'
import { API } from '../../api'

const Profile = () =>{
   const user = JSON.parse(localStorage.getItem("user"))
   const [mypics,setMypics] = useState([])
    useEffect(()=>{
        fetch(`${API}/mypost`,{
            headers:{
                "Authorization":"Bearer "+localStorage.getItem("jwt")
            }
        })
        .then(res=>res.json())
        .then(result=>{
            console.log(result.mypost)
            setMypics(result.mypost)

        })
    },[])
    return(
        <div style={{maxWidth:"550px",margin:"0px auto"}}>
            <div style={{
                display:"flex",
                justifyContent:"space-around",
                margin:"18px 0px",
                borderBottom:"1px solid grey"
            }}>
                <div>
                    <img style={{width:"160px",height:"160px",borderRadius:"80px"}}
                    src={user.photo} alt="hello"
                    ></img>
                </div>
                <div>
                    <h4 className="brand-logo">{user.name}</h4>
                        <div style={{display:"flex",justifyContent:"space-between",width:"108%"}}>
                          <h6>{mypics.length}posts</h6>
                            <h6>{user.followers.length} followers</h6>
                            <h6>{user.following.length} following</h6>
                        </div>
                </div>
            </div>
            <div className="gallery">
            {
                    mypics.map(item=>{
                        return(
                        <img key={item._id} src={item.photo} alt={item.title} style={{height:"200px",width:"200px"}}></img>
                        )
                    })
                }
              
            </div>
        </div>

    )
}

export default Profile